import axios, { AxiosInstance } from "axios";

import { API_URL } from "@/config/app.config";

const axiosInstance = (
  token?: string,
  isFullAxiosResponse = false,
  h?: Record<string, string>
): AxiosInstance => {
  const headers: Record<string, string> = {
    ...h,
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const instance = axios.create({
    baseURL: API_URL,
    timeout: 30 * 1000,
    headers,
  });

  instance.interceptors.response.use(
    (response) => {
      if (isFullAxiosResponse) return response;
      return response.data;
    },
    (error) => {
      return Promise.reject(error?.response);
    }
  );

  return instance;
};

export default axiosInstance;
